import React from "react";
import { Divider } from "../../BP2Components";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import BannerSettings from "../WidgetsSettings/WebWidgets/BannerWeb/BannerSettingsModal";
import IntlMessages from "@util/IntlMessages";

const BannerWidget = ({ value, role }) => {
   return (
      <>
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            title={<IntlMessages id="web.bannerWidget" />}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetId={value.id}
                     widgetName={value.name}
                     icon="setting"
                     deleteIcon="true"
                     children={<BannerSettings value={value} />}
                  />
               )
            }
         >
            <strong>
               <IntlMessages id="settings.bannerWidgetTitleTranslationKey" /> :
            </strong>{" "}
            {value.bannerWidgetTitleTranslationKey}
            <Divider />
            <strong>
               <IntlMessages id="settings.buttonTitleTranslationKey" /> :
            </strong>{" "}
            {value.buttonTitleTranslationKey}
            <Divider />
            <strong>
               <IntlMessages id="settings.widgetKey" /> :
            </strong>{" "}
            {value.widgetKey}
         </Widget>
      </>
   );
};

export default BannerWidget;
